"use client";

import { useEffect } from "react";
import { motion, stagger, useAnimate } from "motion/react";
import { Text } from "../../ui/text";
import { FloatingImages } from "../../common/floating-images";

import { useHeroParallax, UseHeroParallaxProps } from "./use-hero-parallax";
import { ButtonGroup } from "../../util/button-group";

export type HeroParallaxProps = UseHeroParallaxProps;

export const HeroParallax = (props: HeroParallaxProps) => {
  const {
    className,
    styles,
    sectionName,
    images,
    data: { title, description, theme, buttons },
  } = useHeroParallax(props);
  const [scope, animate] = useAnimate();

  useEffect(() => {
    animate(
      "img",
      { opacity: [0, 1] },
      { duration: 0.5, delay: stagger(0.15) }
    );
  }, []);

  return (
    <section
      data-component-name={sectionName}
      className={styles.base({ className })}
    >
      <span className={styles.gradient()} />
      <div className={styles.wrapper()} ref={scope}>
        <motion.div
          className={styles.container()}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.88, delay: 1.5 }}
        >
          <div className={styles.content()}>
            {title && (
              <Text tag="h2" size="h1" className={styles.title()}>
                {title}
              </Text>
            )}
            {description && (
              <Text
                className={styles.description()}
                size="description"
                weight="medium"
              >
                {description}
              </Text>
            )}
            {buttons && (
              <ButtonGroup
                data={{
                  buttons,
                }}
                sectionName={sectionName}
                theme={theme}
                className="z-10"
              />
            )}
          </div>
        </motion.div>
        <FloatingImages images={images} />
      </div>
      <div className={styles.bg()} />
    </section>
  );
};
